import { Link } from '@tanstack/react-router';
import { Button, H1, Paragraph } from 'tamagui';
import { Screen } from '@mrrmlab/ui';

export function HomeRoute() {
  return (
    <Screen>
      <H1>mrrmlab</H1>
      <Paragraph>
        Welcome. This is the learning playground for the mrrmlab monorepo —
        the first real feature is a cross-platform shopping list.
      </Paragraph>
      <Link to="/lists" style={{ textDecoration: 'none' }}>
        <Button>Open shopping lists</Button>
      </Link>
    </Screen>
  );
}
